import { useEffect, useRef } from 'react';
import api from '../services/api';
import { isUserAnalyticsEnabled } from '../services/configuration/config';

export function userClickAnalytics(userId: string) {
  const clickCountRef = useRef(0);
  const clickBufferRef = useRef<any[]>([]);

  useEffect(() => {
    const handleClick = async (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const id: string =
        target.getAttribute('analytics-id') ||
        target.id ||
        target
          .closest('.navigation-bar2-nav-item')
          ?.querySelector('.navigation-bar2-nav-item-label')
          ?.textContent?.trim() ||
        'unknown';
      const payload = {
        element: id,
        path: window.location.pathname,
        timestamp: new Date().toISOString(),
        userId,
      };
      clickBufferRef.current.push(payload);
      clickCountRef.current += 1;
      if (clickCountRef.current >= 10) {
        const bufferToSend = [...clickBufferRef.current];
        clickBufferRef.current = [];
        clickCountRef.current = 0;

        const isEnabled = await isUserAnalyticsEnabled();
        if (!isEnabled) {
          return;
        }

        try {
          await api.post(`/Analytics/click`, JSON.stringify(bufferToSend));
        } catch (err) {
          console.error('Failed to send analytics data', err);
          clickBufferRef.current.unshift(...bufferToSend);
          clickCountRef.current = clickBufferRef.current.length;
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [userId]);
}
